(() => {
  // app/scripts/view-toggle.js
  var LOCAL_STORAGE_KEY = "view-toggle";
  var ViewToggle = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.handleChange = this.handleChange.bind(this);
    }
    connectedCallback() {
      this.input.addEventListener("change", this.handleChange);
    }
    disconnectedCallback() {
      this.input.removeEventListener("change", this.handleChange);
    }
    handleChange(event) {
      const { checked } = this.input;
      localStorage.setItem(LOCAL_STORAGE_KEY, checked ? "list-view" : "grid-view");
    }
  };
  customElements.define("view-toggle", ViewToggle);
})();
